import { gql } from "@apollo/client";

export const CREATE_SUPPORT_TICKET = gql`
  mutation CreateSupportTicket($request: SupportTicketRequestInput!) {
    createSupportTicket(request: $request) {
      id
      saleOrderCode
      issueSupportTemplateId
      issueSupportTemplateName
      providerContactId
      providerName
      contactType
      priority
      compiledSubject
      sentToEmail
      emailStatus
      emailSentAt
      createdAt
    }
  }
`;

export const RETRY_SUPPORT_TICKET_EMAIL = gql`
  mutation RetrySupportTicketEmail($id: UUID!) {
    retrySupportTicketEmail(id: $id) {
      id
      emailStatus
      emailSentAt
    }
  }
`;
